export default __webpack_public_path__ + "static/media/logo.6b107ff3.svg";